import { EnvironmentType } from './enviroment-type';

const env = (window as any)['env'] || {};

export const hosts = {
  API_BASE: env['API_BASE'],
};
export const environment = {
  production: env['PRODUCTION'] ?? false,
  appVersion: require('../../package.json').version,
  type: EnvironmentType[env['TYPE']],
  SITE_BASE_LOGIN: env['SITE_BASE_LOGIN']
};
